/**
 * Frontend metadata for the Product Creative flow.
 *
 * Credit cost is NOT mirrored here. The UI reads the canonical per-resolution
 * price from `credit_costs` via `useCreditCosts().getImageGenerateCost(
 * resolution, PRODUCT_CREATIVE_MODEL_ID)` × imageCount — the exact source the
 * server charges from. No bundle, no markup.
 */

/** Fixed model for this flow. Mirror of server PRODUCT_CREATIVE_MODEL_ID. */
export const PRODUCT_CREATIVE_MODEL_ID = "nano-banana-2";

export const PRODUCT_CREATIVE_MIN_UPLOADS = 1;
export const PRODUCT_CREATIVE_MAX_UPLOADS = 3;
export const PRODUCT_CREATIVE_MIN_IMAGES = 1;
export const PRODUCT_CREATIVE_MAX_IMAGES = 10;
export const PRODUCT_CREATIVE_DEFAULT_IMAGES = 2;

/** Example "before / after" pair shown in the hero before the user uploads. */
const CDN_BASE = "https://cdn.todowith.ai/generated/2ae2c1db-53d0-4920-9cf4-a6b5a96db17b";
export const PRODUCT_CREATIVE_EXAMPLE_BEFORE = `${CDN_BASE}/hero-product-creative-before.webp`;
export const PRODUCT_CREATIVE_EXAMPLE_AFTER = `${CDN_BASE}/hero-product-creative-after.webp`;
